import React from "react";
import ScopedListing from "./ScopedListing";
import { useI18n } from "../lib/i18n";

/* Products whose current price sits below their compare-at price. */
const SCOPE = { on_sale: true };

export default function EndirimPage() {
  const { t } = useI18n();
  return (
    <ScopedListing
      scope={SCOPE}
      saleOnly
      categoryLinks
      path="/endirim"
      testId="sale-page"
      listName="sale"
      heroIndex={6}
      eyebrow={t("sale.eyebrow", "Endirim")}
      title={t("sale.title", "Endirimli məhsullar")}
      description={t(
        "sale.description",
        "Qiyməti azaldılmış parçalar. Ölçü və rəng seçimi tükənənə qədər davam edir.",
      )}
      emptyTitle={t("sale.empty", "Hazırda endirimli məhsul yoxdur")}
      emptyDescription={t(
        "sale.empty_help",
        "Endirim başlayanda məhsullar burada görünəcək.",
      )}
    />
  );
}
